import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { Mutations } from "@/store/enums/StoreEnums";
import axios from "axios";

export class ExternalConfig {
  KEYCLOAK_URL: string;
  KEYCLOAK_REALM: string;
  KEYCLOAK_CLIENT_ID: string;

  constructor() {
    // fallback keycloak options form env files
    this.KEYCLOAK_URL = process.env.VUE_APP_KEYCLOAK_URL;
    this.KEYCLOAK_REALM = process.env.VUE_APP_KEYCLOAK_REALM;
    this.KEYCLOAK_CLIENT_ID = process.env.VUE_APP_KEYCLOAK_CLIENT_ID;
  }
}

@Module({ name: "externalConfig" })
export default class ExternalConfigModule extends VuexModule {
  private config = new ExternalConfig();

  get externalConfig(): ExternalConfig {
    return this.config;
  }

  @Mutation
  [Mutations.SET_EXTERNAL_CONFIG](config: ExternalConfig) {
    this.config = config;
  }

  @Action
  getExternalConfigAction() {
    return new Promise<void>((resolve, reject) => {
      axios
        .get(process.env.BASE_URL + "config.json")
        .then((response) => {
          const config: ExternalConfig = response.data;
          // use config.json file only for production mode, env files otherwise
          if (process.env.NODE_ENV == "production") {
            this.context.commit(Mutations.SET_EXTERNAL_CONFIG, config);
          }

          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
}
